
import Component from '../src/components/Internal/ExternalAdUnitMediaAlpha.vue';

// Register component globally without any prefix if Vue is available.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('external-ad-unit-media-alpha', Component);
}

export default Component;
    